import { FieldType, MeasurementUnits } from '../../../../shared/enums';
import { FieldSettingsModel } from '../../common-models/field-settings.model';
import { RangeFieldValidator } from '../../../../shared/zoneiqui/field-validators';
import { ITableFieldsConfiguration } from 'src/app/interfaces/tables/table-fields-configuration.interface';

function calibrationParkingFieldsFactory() {
    return [
        new FieldSettingsModel('Residential', FieldType.NUMBER, MeasurementUnits.SPACES_PER_UNIT, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('ResidentialVisitors', FieldType.NUMBER, MeasurementUnits.SPACES_PER_UNIT, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('ResidentialTODBenefitReduction', FieldType.NUMBER, MeasurementUnits.PERCENT, {
            validators: [new RangeFieldValidator(0, 100)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('LodgingRooms', FieldType.NUMBER, MeasurementUnits.SPACES_PER_UNIT, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('LodgingVisitors', FieldType.NUMBER, MeasurementUnits.SPACES_PER_UNIT, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('LodgingTODBenefitReduction', FieldType.NUMBER, MeasurementUnits.PERCENT, {
            validators: [new RangeFieldValidator(0, 100)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('Office', FieldType.NUMBER, MeasurementUnits.SPACES_PER_AREA, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('OfficeTODBenefitReduction', FieldType.NUMBER, MeasurementUnits.PERCENT, {
            validators: [new RangeFieldValidator(0, 100)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('Commercial', FieldType.NUMBER, MeasurementUnits.SPACES_PER_AREA, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('CommercialTODBenefitReduction', FieldType.NUMBER, MeasurementUnits.PERCENT, {
            validators: [new RangeFieldValidator(0, 100)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('CivicAssembly', FieldType.NUMBER, MeasurementUnits.SPACES_PER_PERSON, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('CivicTODBenefitReduction', FieldType.NUMBER, MeasurementUnits.PERCENT, {
            validators: [new RangeFieldValidator(0, 100)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('TODMaxDistanceToStation', FieldType.NUMBER, MeasurementUnits.FEET, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        }),
        new FieldSettingsModel('TODMinDistanceToLowDensity', FieldType.NUMBER, MeasurementUnits.FEET, {
            validators: [new RangeFieldValidator(0)],
            isLongMeasurementSection: true
        })
    ];
}

export default { fieldsFactory: calibrationParkingFieldsFactory } as ITableFieldsConfiguration;
